/**
 * Extracts URLs from a text string
 * @param text The text to extract URLs from
 * @returns An array of URLs found in the text
 */
export const extractUrlsFromText = (text: string): string[] => {
  if (!text) return [];
  
  // Regular expression to match URLs
  const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)|([a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}\/?[^\s]*)/g;
  
  // Find all matches
  const matches = text.match(urlRegex);
  
  // Return empty array if no matches
  if (!matches) return [];
  
  // Return unique URLs
  return [...new Set(matches)];
};

/**
 * Ensures a URL starts with https://
 * @param url The URL to ensure has https://
 * @returns The URL with https:// prefix
 */
export const ensureHttps = (url: string): string => {
  // Trim any whitespace from the URL
  url = url.trim();

  // Check if the URL starts with "http://" or "https://"
  if (!/^https?:\/\//i.test(url)) {
    // Prepend "https://" if neither is present
    url = `https://${url}`;
  }

  return url;
};
